// Strips the leading "— " (or "–"/"-") left over in front of each feature
// card's body text now that the <strong> label renders on its own line.
// Runs against the live-rendered description only; product content itself
// is untouched.
document.querySelectorAll('.product__description h3 + p + ul li').forEach(function (li) {
  var strong = li.querySelector('strong');
  if (!strong) return;

  var node = strong.nextSibling;
  while (node && node.nodeType === 3 && !node.textContent.trim()) {
    node = node.nextSibling;
  }

  if (node && node.nodeType === 3) {
    node.textContent = node.textContent.replace(/^\s*[—–-]\s*/, '');
  }
});
